import { iButtonProps } from '@/types/app.types';
import React from 'react';
import './styles.css';
import { Loader2 } from 'lucide-react';
import { cn } from '@/utils';
import { BUTTON_STYLE, BUTTON_TYPE } from '@/app.constants';

const Button = React.forwardRef<HTMLButtonElement, iButtonProps>((props, ref) => {
  const {
    ofType = BUTTON_TYPE.REGULAR,
    ofStyle = BUTTON_STYLE.FILLED,
    alignIcon = 'left',
    iconSize = 20,
    loading = false,
    disabled = false,
    icon,
    iconColor,
    children,
    dataTestId,
    className,
    contentClassName,
    ...rest
  } = props;

  const buttonClass = `${className || ''} omniful-${ofType}-btn omniful-${ofStyle}-btn`;

  const Icon = icon;

  return (
    <button
      data-testid={dataTestId}
      className={cn('flex items-center justify-center omniful-button', buttonClass)}
      disabled={loading || disabled}
      {...rest}
      ref={ref}
    >
      <span className={cn(
        'button-content-container flex items-center justify-center gap-[12px] border-none',
        contentClassName
      )}
      >
        {loading && alignIcon === 'left' && <Loader2 size={16} className='animate-spin' />}
        {!loading && Icon && alignIcon === 'left' && <Icon size={iconSize} color={iconColor} />}
        {children}
        {!loading && Icon && alignIcon === 'right' && <Icon size={iconSize} color={iconColor} />}
        {loading && alignIcon === 'right' && <Loader2 size={16} className='animate-spin' />}
      </span>
    </button>
  );
});

Button.displayName = 'Button';

export default Button;